import { useEffect, useState } from "react";
import { Link, useOutletContext } from "react-router-dom";
import { toast } from "sonner";
import { api, fmtErr } from "../../lib/api";

const STAGES = [
  ["new", "New"], ["contacted", "Contacted"], ["viewing_scheduled", "Viewing Scheduled"],
  ["viewed", "Viewed"], ["application", "Application"], ["leased", "Leased (Won)"], ["lost", "Lost"],
];

export default function Leads() {
  const [leads, setLeads] = useState([]);
  const [agents, setAgents] = useState([]);
  const [q, setQ] = useState("");
  const { refreshStats } = useOutletContext() || {};

  const load = () => {
    api.get("/admin/leads", { params: q ? { q } : {} }).then((r) => setLeads(r.data)).catch((e) => toast.error(fmtErr(e)));
  };
  useEffect(() => { load(); }, [q]); // eslint-disable-line
  useEffect(() => { api.get("/admin/users").then((r) => setAgents(r.data.filter((u) => ["agent", "admin"].includes(u.role)))).catch(() => {}); }, []);

  const move = async (id, status) => {
    try { await api.patch(`/admin/leads/${id}`, { status }); load(); refreshStats?.(); }
    catch (e) { toast.error(fmtErr(e)); }
  };
  const assign = async (id, assigned_agent_id) => {
    try { await api.patch(`/admin/leads/${id}`, { assigned_agent_id: assigned_agent_id || null }); load(); }
    catch (e) { toast.error(fmtErr(e)); }
  };

  return (
    <div data-testid="leads-board">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-6">
        <div>
          <h1 className="font-heading font-bold text-2xl tracking-tight">Leads pipeline</h1>
          <p className="text-sm text-muted-foreground">{leads.length} leads</p>
        </div>
        <input data-testid="leads-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search name or email"
          aria-label="Search leads" className="rounded-xl border border-input bg-background px-4 py-2 text-sm w-64" />
      </div>
      <div className="overflow-x-auto -mx-4 px-4 pb-4">
        <div className="flex gap-4 min-w-max">
          {STAGES.map(([key, label]) => {
            const items = leads.filter((l) => l.status === key);
            return (
              <div key={key} className="w-72 shrink-0" data-testid={`kanban-col-${key}`}>
                <div className="flex items-center justify-between mb-3 px-1">
                  <h2 className="text-xs uppercase tracking-wider font-semibold text-muted-foreground">{label}</h2>
                  <span className="rounded-full bg-secondary px-2 py-0.5 text-xs font-bold">{items.length}</span>
                </div>
                <div className="space-y-3">
                  {items.map((l) => (
                    <div key={l.id} data-testid={`lead-card-${l.id}`} className="rounded-xl border border-border bg-card p-4 shadow-sm">
                      <Link to={`/dashboard/leads/${l.id}`} className="font-semibold text-sm hover:text-primary">{l.first_name} {l.last_name}</Link>
                      <p className="mt-1 text-xs text-muted-foreground">{(l.criteria?.locations || []).join(", ") || "Anywhere"}</p>
                      <p className="text-xs text-muted-foreground">${(l.budget_min || 0).toLocaleString()}–${(l.budget_max || 0).toLocaleString()}/mo · {(l.beds || []).join("/") || "any"} bed</p>
                      <p className="mt-1 text-[11px] text-muted-foreground">{l.created_at?.slice(0, 10)}{l.selected_ids?.length ? ` · ${l.selected_ids.length} viewings` : ""}</p>
                      <div className="mt-3 flex gap-2">
                        <select data-testid={`lead-stage-${l.id}`} value={l.status} onChange={(e) => move(l.id, e.target.value)} aria-label="Move stage"
                          className="flex-1 rounded-lg border border-input bg-background px-2 py-1 text-xs">
                          {STAGES.map(([v, lab]) => <option key={v} value={v}>{lab}</option>)}
                        </select>
                        <select data-testid={`lead-assign-${l.id}`} value={l.assigned_agent_id || ""} onChange={(e) => assign(l.id, e.target.value)} aria-label="Assign agent"
                          className="flex-1 rounded-lg border border-input bg-background px-2 py-1 text-xs">
                          <option value="">Unassigned</option>
                          {agents.map((a) => <option key={a.id} value={a.id}>{a.name}</option>)}
                        </select>
                      </div>
                    </div>
                  ))}
                  {!items.length && <div className="rounded-xl border border-dashed border-border p-4 text-center text-xs text-muted-foreground">No leads yet</div>}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
